import { defineMessages } from 'react-intl';

export default defineMessages({
  seoTitle: {
    id: 'cc4.seo.sharable-claim-page-legal-guardian.title',
    defaultMessage: '',
  },
  seoDescription: {
    id: 'cc4.seo.sharable-claim-page-legal-guardian.description',
    defaultMessage: '',
  },
  sharableClaimPageTitle: {
    id: 'cc4.form.shareable-claim-page-legal-guardian.title',
    defaultMessage: `Complete permission to handle claim for {minor}`,
  },
  sharableClaimPageSubTitle: {
    id: 'cc4.form.shareable-claim-page-legal-guardian.sub-title',
    defaultMessage: `{count, plural,
      one {Fill in full name and draw signature of the <primary>first legal guardian</primary>}
      other {Fill in full name and draw signature of the <primary>second legal guardian</primary>}
    }`,
  },
  asideText: {
    id: 'cc4.form.sharable-claim-page-legal-guardian.aside-text',
    defaultMessage:
      'We need a signed Power of Attorney to represent you and your co-passengers.',
  },
  backButton: {
    id: 'cc4.form.claim-page-legal-guardian.button.back-button',
    defaultMessage: 'Back',
  },
  continueButton: {
    id: 'cc4.form.sharable-claim-page-legal-guardian.button.continue-button',
    defaultMessage: 'Continue',
  },
  checkboxSingleParent: {
    id:
      'cc4.form.sharable-claim-page-legal-guardian.button.checkbox-single-parent',
    defaultMessage:
      'I hereby confirm that I am a single parent or have the sole custody of the minor',
  },
});
